import apiClient from '../lib/apiClient';

export const fetchUserDetails = async (userId: number) => {
  const response = await apiClient.get(`/patients/${userId}/`);

  return response?.data;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const deleteUser = async (userId: any) => {
  const response = await apiClient.delete(`/patients/${userId}`);

  return response?.data;
};

export const fetchCountries = async () => {
  const response = await apiClient('/constants?key=country_list');
  return response?.data;
};

export const fetchCities = async (countryCode: string) => {
  const response = await apiClient.get(
    `/constants?key=address&country=${countryCode}`
  );
  return response?.data;
};
